// eslint-disable-next-line import/no-cycle
import api from '@/services/api';

const URL = '/mercado-hoje';

export default {
  async fetchProdutosMercadoHoje({ commit, dispatch }, filtros) {
    dispatch('toggleLoading', true, { root: true });

    const keys = Object.keys(filtros);
    const params = new URLSearchParams();

    /* eslint-disable */
    for (const key of keys) {
      if (filtros[key]) {
        params.append(key, filtros[key]);
      }
    }

    const { data } = await api.get(URL, { params });

    commit('SET_LISTA_PRODUTOS', data.data);
    commit('paginacao/SET_PAGINADOR', data, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit, dispatch }, payload) {
    commit('SET_FILTROS', payload);

    return dispatch('fetchProdutosMercadoHoje', payload);
  },
  async prepararExcelMercadoHoje() {
    const { data } = await api.get(`${URL}/excel`);

    return data;
  }
};
